const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const baseURL = process.env.REACT_APP_API_URL || (isDev ? 'http://localhost:5000/api' : '');

export const endpoints = {
  login:       `${baseURL}/auth/login`,
  userProfile: `${baseURL}/auth/profile`,
  register:    `${baseURL}/auth/register`,
  logout:      `${baseURL}/auth/logout`,
  googleLogin: `${baseURL}/auth/google`,
  refresh:     `${baseURL}/auth/refresh`,

  myEvents:    `${baseURL}/calendar`,
  createEvent: `${baseURL}/calendar`,
  busyTimes:   (userId: string) => `${baseURL}/calendar/busy/${userId}`,
  profile:     `${baseURL}/users/me`,
  deactivateAccount: `${baseURL}/users/me/deactivate`,
  tutors:      `${baseURL}/tutors`,
  parents:     `${baseURL}/parents`,
  upload:      `${baseURL}/files`,
  createPaymentIntent: `${baseURL}/payment/create-payment-intent`,
  createBookingAndPaymentIntent: `${baseURL}/payment/createBookingAndPaymentIntent`,
  confirmPayment: `${baseURL}/payment/confirm-payment`,
  verifyResend: `${baseURL}/verify/resend`,

  updateEvent: (id: string, occurrenceDate?: string) =>
    occurrenceDate
      ? `${baseURL}/calendar/${id}/occurrence?date=${occurrenceDate}`
      : `${baseURL}/calendar/${id}`,

  deleteEvent: (id: string, occurrenceDate?: string) =>
    occurrenceDate
      ? `${baseURL}/calendar/${id}/occurrence?date=${occurrenceDate}`
      : `${baseURL}/calendar/${id}`,

  myConnections:    `${baseURL}/connections`,
  createConnection: `${baseURL}/connections`,
  updateConnection: (id: string) => `${baseURL}/connections/${id}`,

  videoToken: `${baseURL}/video/token`,

  adminTutors: `${baseURL}/admin/tutors`,
  adminTutorVerification: (id: string) => `${baseURL}/admin/tutors/${id}/verification`,

  sendMessage: `${baseURL}/messages`,
  getMessages: (connectionId: string) => `${baseURL}/messages/${connectionId}`,
  markMessagesAsRead: `${baseURL}/messages/read`,
}

export { baseURL };
